import validate from "/opt/buildhome/repo/node_modules/nuxt/dist/pages/runtime/validate.js";
import steps_45global from "/opt/buildhome/repo/middleware/steps.global.ts";
export const globalMiddleware = [
  validate,
  steps_45global
]
export const namedMiddleware = {}